import React from 'react';
import { Grid } from 'components/ui/Grid';
import { Button } from 'components/ui/Button';
import { trackingConstant } from 'utils/analytics';

const LeaderboardCard = ({
  heading,
  bottomTitle,
  bottomTitleValue,
  btnText,
  handleBtnClick,
  rankings
}) => {
  return (
    <>
      <div className='si-card--lb'>
        <div className='si-card__top'>
          <div className='si-heading'>{'DAILY QUIZ'}</div>
        </div>
        <div className='si-card__mid'>
          <div className='si-card__list'>
            <Grid>
              <Grid.Body rows={rankings} />
            </Grid>
          </div>
        </div>
        <div className='si-card__bottom'>
          <div className='si-card__bottom-col'>
            <div className='si-card__pts-title'>{bottomTitle}</div>
            <div className='si-card__pts-num'>{bottomTitleValue}</div>
          </div>
          <div className='si-card__bottom-col'>
            {/* <button className='si-btn si-btn--primary' onClick={handleBtnClick}>
              <span>{btnText.toUpperCase()}</span>
              <i className='qz-arrow-right'></i>
            </button> */}
            <Button
              icon={'qz-arrow-right'}
              trackingKey={trackingConstant.VIEW_LEADERBOARD_BUTTON_CLICKED}
              onClick={handleBtnClick}
            >
              {btnText.toUpperCase()}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default LeaderboardCard;
